export const AUTHENTICATE_PERSIST_KEY = 'authenticate';
